import { render, staticRenderFns } from "./FixedBearingsTwisting.vue?vue&type=template&id=48aaeed0&scoped=true"
import script from "./FixedBearingsTwisting.vue?vue&type=script&lang=js"
export * from "./FixedBearingsTwisting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aaeed0",
  null
  
)

export default component.exports